import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ba0e650"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-box" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "item-div" }
const _hoisted_4 = { class: "name-box xag-flex-lr" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "name-text" }
const _hoisted_7 = { class: "explain xag-ellipsis xag-flex" }
const _hoisted_8 = { class: "xag-ellipsis type-addr" }
const _hoisted_9 = {
  key: 0,
  class: "label-tag"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-tag-left" }, "年度", -1))
const _hoisted_11 = { class: "label-tag-right" }
const _hoisted_12 = {
  key: 1,
  class: "v-line"
}
const _hoisted_13 = {
  key: 3,
  class: "v-line"
}
const _hoisted_14 = { class: "distance-text" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "no-data-box"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "device-no-data-icon common-icon" }),
  /*#__PURE__*/_createElementVNode("div", null, "暂无维修网点")
], -1))
const _hoisted_18 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_NameTag = _resolveComponent("NameTag")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createBlock(_component_van_pull_refresh, {
    modelValue: _ctx.refreshing,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.refreshing) = $event)),
    onRefresh: _ctx.onRefresh,
    class: "items-box"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_van_list, {
        loading: _ctx.loading,
        "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
        finished: _ctx.finished,
        error: _ctx.error,
        "onUpdate:error": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.error) = $event)),
        "error-text": "请求失败，点击重新加载",
        onLoad: _ctx.onLoad,
        class: _normalizeClass({ 'xag-flex-center': !_ctx.items.length && _ctx.finished })
      }, {
        finished: _withCtx(() => [
          (_ctx.items.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, "没有更多了"))
            : (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item xag-flex",
                key: item.guid,
                onClick: ($event: any) => (_ctx.onClickItem(item))
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      (item.subTypeTagText)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "sub-type-tag",
                            style: _normalizeStyle({ backgroundColor: item.subTypeTagBgColor })
                          }, _toDisplayString(item.subTypeTagText), 5))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(item.name), 1)
                    ]),
                    _createVNode(_component_van_icon, { name: "arrow" })
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      (item.labelName)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                            _hoisted_10,
                            _createElementVNode("span", _hoisted_11, _toDisplayString(item.labelName), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (item.labelName)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, "|"))
                        : _createCommentVNode("", true),
                      (item.status === false && item.type === 'AUTH_WAREHOUSE')
                        ? (_openBlock(), _createBlock(_component_NameTag, { key: 2 }))
                        : _createCommentVNode("", true),
                      (item.status === false && item.type === 'AUTH_WAREHOUSE')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, " | "))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(item.dis), 1)
                    ])
                  ])
                ])
              ], 8, _hoisted_2))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["loading", "finished", "error", "onLoad", "class"])
    ]),
    _: 1
  }, 8, ["modelValue", "onRefresh"]))
}